import useAuth from 'hooks/useAuth';
import { useQuery } from 'react-query';

export default function useDocuments(userId: string) {
  const url = `/user/${userId}/documents`;
  const { request } = useAuth();

  const { data: documents, refetch: refetchDocuments } = useQuery(url, () =>
    request.get(url).then((r) => r.data.map((item) => ({ ...item, id: item._id })) as Document[])
  );

  return { documents, refetchDocuments };
}

export interface UploadedBy {
  _id: string;
  fullName: string;
}

export interface Metadata {
  name: string;
  description: string;
  uploadedBy: UploadedBy;
}

export interface Document {
  fileType: string;
  id: string;
  _id: string;
  user: string;
  key: string;
  bucket: string;
  mimeType: string;
  size: number;
  location: string;
  name: string;
  metadata: Metadata;
  createdAt: Date;
  updatedAt: Date;
  __v: number;
}
